import React, { createContext, useState } from 'react';
import { HashRouter as Router, Route} from 'react-router-dom';
import Home from './Home';
import ShowResult from './ShowResult';

const PoemContext = createContext([{}, () => {}]);

function App() {
  const [poem, setPoem] = useState({});
  return (
    <div>
      <PoemContext.Provider value={[poem, setPoem]}>
        <Router>
          <div>
            <Route exact path="/" component={Home} />
            <Route path="/ShowResult" component={ShowResult} />
          </div>
        </Router>
      </PoemContext.Provider>
    </div>
  );
}

export default App;
export {PoemContext};

